import { gql } from 'graphql-tag';

// Mutation to start the annual purchases export job
export const EXPORT_ANNUAL_PURCHASES = gql`
  mutation GetAnnualPurchaseListV2($input: AnnualPurchaseListInput!) {
    getAnnualPurchaseListV2(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export status
export const ANNUAL_PURCHASES_EXPORT_STATUS = gql`
  subscription AnnualPurchaseListExportStatus($jobId: String!) {
    annualPurchaseListExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
    }
  }
`;

// Query to get download URL when complete
export const GET_ANNUAL_PURCHASES_EXPORT_DOWNLOAD_URL = gql`
  query GetAnnualPurchaseListExportDownloadUrl($jobId: String!) {
    getAnnualPurchaseListExportDownloadUrl(jobId: $jobId)
  }
`;
